module.exports = __webpack_public_path__ + "img/pause-left.af5e2b05.svg";